module.exports = __webpack_public_path__ + "static/img/9.6b5b144.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/4/zh/9.png
// module id = LVAq
// module chunks = 0